module.exports = __webpack_public_path__ + "static/media/flowchart_division.34a41be2.png";